<template>
    <div class="home">
        <h4 class="bold text-uppercase">
            Cài đặt Site đại lý: <a :href="agency.agency_domain" target="_blank">{{ agency.agency_domain }}</a>
        </h4>
        <div v-for="(item, index) in admin" :key="index" class="mt-3">
            <hr />
            <h5 class="bold align-items-center">
                <i class="material-icons mr-1 icon-button" style="vertical-align: sub;">{{ item.icon }}</i>
                {{ item.name }}
            </h5>
            <div class="row mt-2">
                <div class="col-md-3 col-12 mb-3" v-for="(child, index) in item.childs" :key="index">
                    <button
                        @click="$router.push(child.to)"
                        type="button"
                        class="btn btn-dark-blue btn-md btn-block h-100"
                    >
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <i class="material-icons icon-button">{{ child.icon }}</i>
                            </div>
                            <div class="col pl-0 text-left">
                                {{ child.name }}
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import admin from "./config/admin-agency-lv2"
export default {
    data() {
        return {
            admin: admin,
            selectSite: {}
        }
    },
    computed: {
        agency() {
            return this.$store.state.agency
        }
    },
    created() {
        this.$store.dispatch("GET_SITE_AGENCY_INFO", this.agency.agency_domain)
    }
}
</script>
